<template>
  <div id="app" v-bind:class="[langClass]">
    <Header v-on:toggleMobileMenu="toggleMobileMenu" v-if="displayHeader" :username="userName" :activeApps="activeApps" :logo="logo" :userType="userType" :loginHistory="formattedLoginHistory"></Header>
    <!-- <div class="NAME" v-for="log in logs">{{log}}</div> -->
    <div class="mainView" v-bind:class="[activeApps, openMobileMenu ? 'openMenu' : '']" id="spaContainer"></div>
    <iframe class="crm-iframe" ref="crmIframe" v-if="wasCRMLink || isCRMUser && CRMLoginLink" v-show="isCRMActive" :src="CRMLoginLink || 'about:blank'"></iframe>
    <call-toaster />
  </div>
</template>

<script>
import consts from "./consts.js";
import {getActiveApps} from "./spa/externalApi";
import Header from "./components/Header.vue";
import {EventBus, history} from "./event-bus.js";
import LocalStorageManager from "./LocalStorageManager.js";
import callToaster from "./AgentToolbar/CallToaster.vue";
import {isLoginPage} from "./login-status";

export default {
	name: "app",
	components: {Header, callToaster},
	data: () => ({
		lang: null, activeApps: [], logo: null, userType: null, displayHeader: false, openMobileMenu: false, userName: "", CRMLoginLink: null, serverLink: null, wasCRMLink: false, crmIntegrationLoaded: false, loginHistory: null
	}),
	computed: {
		langClass() {
			if (this.activeApps.includes("pbx")) {
				return "Lang" + "EN";
			}
			else if (this.activeApps.includes("crm")) {
				return "Lang" + "HE";
			}
			return "Lang" + this.lang.toUpperCase();
		},
		isCRMActive() {
			return this.activeApps.includes("crm");
		},
		isCRMUser() {
			return consts.PRODUCT.is(consts.PRODUCT.CRM, this.userType);
		},
		isPBXActive() {
			return this.activeApps.includes("pbx");
		},
		formattedLoginHistory() {
			let history = Array.isArray(this.loginHistory) ? this.loginHistory : JSON.parse(this.loginHistory || "[]");

			const makeLabel = (item) => {
				return item.userName;
			};
			return history.map((item, index) => {
				return {index, label: makeLabel(item), raw: item};
			});
		}
	},
	created() {
		console.info("main app created");

		history.listen((location) => {
			this.openMobileMenu = false;
		});

		// EventBus.$on("USER_LOGIN", () => { setTimeout(() => this.updateCRMLink(), 800) });
		EventBus.$on("USER_SWITCH", () => this.updateCRMLink());
		EventBus.$on("USER_LOGOFF", () => {
			console.error("CRM: move to empty frame");
			this.CRMLoginLink = null;
		});

		EventBus.$on("crm:openmodal", (message) => {
			if (this.$refs.crmIframe) {
				this.$refs.crmIframe.contentWindow.postMessage({...message, type: "openModal"}, "*");
			}
			else {
				console.warn("trying to send message when no crm iframe");
			}
		});

		this.LSM = new LocalStorageManager(this);
		window.LSM = this.LSM;
		console.info("LSM created");

		const receiveMessage = (event) => {
			if (event.data.source && event.data.source.indexOf("vue-devtools") == 0) {
				return;
			}
			// alert("RECEIVED MESSAGE\n" + JSON.stringify(event.data));
			// this.logs.push(JSON.stringify(event.data));
			if (event.data.source && event.data.source == "crm") {
				if (event.data.type == "alive") {
					console.info("PORTAL Received ALIVE message", event.data);
					this.crmIntegrationLoaded = event.data.val;
					EventBus.$emit("crm:alive", {val: event.data.val, url: event.data.url});
				}
			}
		};
		window.addEventListener("message", receiveMessage, false);

		// this.LSM.systemConfigPromise.then(() => {
		//   this.updateCRMLink();
		// });
		this.LSM.update();
	},
	mounted() {
		setTitle([]);

		window.addEventListener("storage", (e) => {
			console.info("Portal EVENT: STORAGE CHANGED");
			this.LSM.update();
		});

		this.activeApps = getActiveApps();
		this.displayHeader = !isLoginPage();
		window.addEventListener("hashchange", evt => {
			console.info("Portal EVENT: HASH CHANGED");
			this.displayHeader = !isLoginPage();
		});
		window.addEventListener("single-spa:app-change", evt => {
			console.info("Portal EVENT: APP CHANGED");
			this.activeApps = getActiveApps();
			setTitle(this.activeApps);
		});
		if (this.isCRMActive) {
			this.updateCRMLink();
		}
	},
	methods: {
		toggleMobileMenu() {
			this.openMobileMenu = !this.openMobileMenu;
		},

		async updateCRMLink() {
			if (!this.LSM.systemConfig) {
				this.LSM.$on("LSM:SystemConfigFetched", () => this.updateCRMLink());
				return;
			}
			console.info("isCRMUser?", this.isCRMUser);
			if (!this.isCRMUser) {
				this.CRMLoginLink = null;
				console.info("CRM: this is not CRM user"); return null;
			}
			try {
				const response = await fetch(this.LSM.systemConfig.serverUrl + "/proxy/crm/connect", {headers: {Authorization: "Bearer " + localStorage.token}});
				const text = await response.text();
				const result = text[0] === "{" ? JSON.parse(text) : text;

				console.log("receive from CRM", response);
				if (response.status >= 300) {
					throw new Error(text);
				}
				this.wasCRMLink = !!result.url;
				if (!this.wasCRMLink) {
					throw new Error(text);
				}
				this.CRMLoginLink = result.url;
			}
			catch (error) {
				this.CRMLoginLink = null;
				this.wasCRMLink = false;
				console.error("CRM: we had error", error.message || error);
				alert("CRM: error-" + error.message || error);
			}
		}
	},
	watch: {
		isCRMActive(currentState, prevState) {
			if (currentState && !this.CRMLoginLink) {
				this.updateCRMLink();
			}
			if (!currentState) {
				this.crmIntegrationLoaded = false;
			}
		}
	}
};

function setTitle(activeApps) {
	let parts = [];
	if (isLoginPage()) {
		parts.push("Login");
	}
	else {
		switch (activeApps[0]) {
			case "callcenter":
				parts.push("Call Center");
				break;
			case "dialer":
				parts.push("Dialer");
		}
	}
	parts.push(window.whitelabelConfig.titleSuffix);
	document.title = parts.join(" | ");
}
</script>

<style scoped lang="scss">
@import '@/styles/_vars.scss';
body {margin: 0;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  //margin-top: 60px;
}
#spaContainer {
  margin-top: $header_height;
}
.dialer .main {margin-inline-start: $sidebar-width;}
.LangEN {direction: ltr;}
.LangHE {direction: rtl;}
</style>

<style lang="scss">
@import '@/styles/_vars.scss';
// .mainInternal {margin-inline-start: 60px;}
</style>
